import { deleteDoc, doc } from "@firebase/firestore"
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { hideLoading, showLoading } from "./items-delete-slice";
import { deleteItems } from "../items-list/items-list-slice";

// export const getItemsDataService = async (dispatch, db, coll, id) => {
//     try {
//         const docRef = doc(db, coll, id);
//         const docSnap = await getDoc(docRef);
//         if (docSnap.exists()) {
//             return docSnap.data();
//         } else {
//             dispatch(showWarningSnackbar("This document no longer exists."));
//         }
//     } catch(e) {
//         console.error("ItemsDelete getItemsDataService error: ", e);
//     }
// };

export const deleteItemsService = async (dispatch, db, coll, id) => {
    dispatch(showLoading());
    try {
        await deleteDoc(doc(db, coll, id));
        dispatch(deleteItems(id));
        dispatch(showSuccessSnackbar('Deleted successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Delete failed! Please, try again.'));
        console.error("ItemsDelete deleteItemsService error: ", e);
    }
    dispatch(hideLoading());
};